"use client";
import { SwiperProps, Swiper } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
const AppSlider = ({ children, ...otherProps }: SwiperProps) => {
  return <Swiper {...otherProps}>{children}</Swiper>;
};

export default AppSlider;
